import { AxiosConfig } from '../../componentes/axiosConfig';

export class MontarFormulario {
    constructor() {
        this._axios = (new AxiosConfig()).instanciaAxios();
        this._idConainnerForulario   = 'templat-form-rastreavel';
        this._idSelectTipoRastreavel = $('#tipo_id');
    }

    montar () {
        if (this._idSelectTipoRastreavel.length === 0) {
            return;
        }

        this._idSelectTipoRastreavel.on('select2:select', (elemento) => {
            const resposta = elemento.params.data;
            if (resposta.element.attributes['data-formulario']) {
                const formulario = resposta.element.attributes['data-formulario'].value
                this._obterTemplateHtml(formulario);
            }
        });
    }

    _obterTemplateHtml (template) {
        const dominio = window.location.origin;
        const url     = `${dominio}/rastreaveis/campos-form/${template}`;

        this._axios.get(url)
        .then((resposta) => {
            document.getElementById(this._idConainnerForulario).innerHTML = resposta.data;
        })
        .catch((erro) => {
            console.log(erro);
        });
    }
}
